export default __webpack_public_path__ + "static/media/contextual-chocolate.0ee1d21e.png";